import React, { useState, useEffect, lazy } from "react";
import "./App.css";
import Header from "./components/Header";
import Body from "./components/Body";
import axios from "axios";
import ReactGA from "react-ga";
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import NewFooter from "./components/NewFooter/index";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import PricingTable from "./components/PricingTable";
import { CookieSetting } from "cookiesetting-component";

const ReferralBrokerList = lazy(() => import('./components/ReferralDashboard'));
const ReferJob = lazy(() => import('./components/ReferralDashboard/refer'));

function App() {
  const appVersion = appversion.version;
  const [guidelineurlData, setGuidelineurlData] = useState();
  const [textData, setTextData] = useState();
  const [wholesaleurlData, setWholesaleurlData] = useState();
  const [correspondanturlData, setCorrespondanturlData] = useState();
  // ReactGA.initialize("UA-187484893-2");
  ReactGA.pageview(window.location.pathname + window.location.search);

  useEffect(() => {
    const fetchGuidelineURLJSON = async () => {
      await axios.get(process.env.REACT_APP_WHOLESALEANDCORRESPONDENT_GUIDELINES_URL).then(
        (response) => {
          const guidelineurlJsonData = response.data;
          setGuidelineurlData(guidelineurlJsonData);
          setTextData(guidelineurlJsonData.Text);
          setWholesaleurlData(guidelineurlJsonData[0].urlWholesale);
          setCorrespondanturlData(guidelineurlJsonData[1].urlCorrespondant);
        },
        (error) => {
          console.log(error);
        }
      );
    };
    fetchGuidelineURLJSON();
  }, []);

  return (
    <CacheBuster
      currentVersion={appVersion}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
    >
      <>
        <React.Fragment>
          <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
            <Header wholesaleurlData={wholesaleurlData} />
            <Routes>
              <Route exact path="/" element={<Body />} />
              <Route exact path="/dashboard" element={<ReferralBrokerList />} />
              <Route exact path="/refer" element={<ReferJob />} />
            </Routes>
            <NewFooter />
          </BrowserRouter>
        </React.Fragment>
      </>
      <CookieSetting
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    </CacheBuster>
  );
}

export default App;
